export const headCells = [
    {
        id: "sNo",
        numeric: false,
        disablePadding: true,
        label: "S.no",
    },
    {
        id: "patientName",
        numeric: false,
        disablePadding: false,
        label: "Patient Name",
    },
    {
        id: "orderNumber",
        numeric: false,
        disablePadding: false,
        label: "Order Number",
    },
    {
        id: "test",
        numeric: false,
        disablePadding: false,
        label: "Test",
    },
    {
        id: "labName",
        numeric: false,
        disablePadding: false,
        label: "Lab Name",
    },
    {
        id: "dateTimeOfOrder",
        numeric: false,
        disablePadding: false,
        label: "Date & Time of Order",
    },
    {
        id: "priorityLevel",
        numeric: false,
        disablePadding: false,
        label: "Priority Level",
    },
    {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: "Status",
    },
    {
        id: "action",
        numeric: false,
        disablePadding: false,
        label: "Action",
    },
];
